<template>
  <div style="color:#6c757d !important;">
    <!-- ----------------------------------- -->
    <!-- navbar starts -->
    <vs-navbar
      v-model="indexActive"
      :color="colorx"
      text-color="rgba(255,255,255,.6)"
      active-text-color="rgba(255,255,255,1)"
      class="myNavbar"
    >
      <div slot="title">
        <vs-navbar-title>Graphs Presentations</vs-navbar-title>
      </div>
    </vs-navbar>
    <!-- navbar ends -->
    <!-- ----------------------------------- -->
    <!-- container starts -->
    <div class="container mt-5">
      <div class="row">
          <div class="col-sm-12 p-0 print-scr">
             <span class="btn btn-primary float-right btn-sm print-btn" @click="printReport">
            <i class="material-icons">print</i> Print
          </span>
        <vs-breadcrumb
          align="left"
          :items="
                  [
                   {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Admin/adminDashboard'
                    },
                    {
                      title: 'Reports',
                      url: '/#/dashboard/Admin/graphs',
                      active: true
                    }
                  ]"
        ></vs-breadcrumb>
      
         
        </div>
      </div>
    </div>
    <div class="container container-bdr mt-2 mb-5">
      <!-- row starts -->
      <div class="row">
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-12 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Pre & Post Assessment Report</strong>
            </span>
            <span class="float-right">
              <strong>Event Code :</strong> {{trainingDetail.training_code}}
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <img :src="BASEPATHDYNAMIC+'/unodc_logo.png'" class="mt-2 mb-2" alt="UNODC" width="200" />
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Plot # 5-11, Diplomatic Enclave, G-5, P.O.BOX 1051, Islamabad 44000, Pakistan</strong>
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Country Office Pakistan</strong>
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-12 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Name of Event :</strong> {{trainingDetail.title}}
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-8 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Start Date :</strong> {{trainingDetail.startdate}}
            </span>
            <span class="float-right">
              <strong>Finish Date :</strong> {{trainingDetail.enddate}}
            </span>
          </p>
        </div>
        
        <!-- col-md starts -->
        <div class="col-md-12 col-bdr-bottom">
          <p class="mt-2 mb-2">
            <span>
              <strong>Name of Trainer(s) :</strong><span v-if="trainers">
                <strong> ({{trainers.length}}) </strong>
                  <span v-for="(trainer,index) in trainers" :key="index">{{trainer.trainer.name}} - </span>
                </span>
            </span>
          </p>
        </div>
        <!-- col-md ends -->
        <!-- ----------------------------------- -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom pb-2">
          <p class="mt-2 mb-2 text-center">
            <span>
              <strong>Average Actual Knowledge Change</strong>
            </span>
          </p>
          <canvas class="chart-container" id="myChart" width="400" height="400"></canvas>
        </div>
        <!-- col-md ends -->
        <!-- col-md starts -->
        <div class="col-md-4 col-bdr-bottom pb-2" v-for="(question,qindex) in questionsArray" :key="qindex">
          <p class="mt-2 mb-2 text-center">
            <span>
              <strong>{{question.question.title}}</strong>
            </span>
          </p>

          <canvas :id="'question'+qindex" width="400" height="400"></canvas>
        </div>
        
      </div>
      <!-- row ends -->
    </div>
    <!-- container ends -->
  </div>
</template>

<script>
import axios from "axios";
import Chart from "chart.js";
export default {
  data: () => ({
    colorx: "#2196f3",
    basepath: process.env.VUE_APP_BASE_PATH,
    BASEPATHDYNAMIC: process.env.VUE_APP_BASE_PATH,
    training_id:"",
    trainingDetail:[],
    standardQuestions:[],
    trainers:[],
    questionsArray:[],
    labelArray: [],
    counterSelectedOptions: 0,
    counterA : 0,
    indexActive: 0
  }),
 mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.BASEPATHDYNAMIC = process.env.VUE_APP_BASE_PATH;
    this.training_id = this.$route.query.trainingId;
    this.allStandardQuestions();
    this.openLoading();
    axios
      .get(
        process.env.VUE_APP_BASE_PATH +
          "/single/training/traineedetails/standardQuestions/report/get/" +
          this.training_id
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        if (response.data && response.data.training != undefined) {
          this.trainingDetail = response.data.training;
        }
        if(response.data && response.data.trainers != undefined){
          this.trainers = response.data.trainers;
        }
      })
    // chart 1 starts
    new Chart(document.getElementById("myChart"), {
      type: "bar",
      data: {
        labels: ["Post", "Pre"],
        datasets: [
          {
            label: "Percentage",
            data: [12, 19],
            backgroundColor: ["#e74c3c", "#3498db"]
           
          }
        ]
      },
      options: {
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 100,
                callback: function(value) {
                  return value + "%";
                }
              },
              scaleLabel: {
                display: true,
                labelString: "Percentage"
              }
            }
          ]
        }
      }
    });
    
    
  },
  methods: {
    allStandardQuestions(){
      this.openLoading();
    axios
      .get(
        process.env.VUE_APP_BASE_PATH +"/training/standardQuestions/all/get/"+this.training_id
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (
          response.data &&
          response.data.preassesment &&
          response.data.options
        ) {
           setTimeout(() => {
            response.data.questions.forEach((element) => {
              response.data.options.forEach((opt, index) => {
                this.labelArray = [];
                this.selectedOptions = [];
                opt.forEach((oneopt, optindex) => {
                  if (oneopt.questionBank_id == element.question_id) {
                    
                     this.selectedOptions.push(0);
                    response.data.preassesment.forEach((asses) => {
                       if (asses.option_id == oneopt.id) {
                      this.selectedOptions[optindex] = this.selectedOptions[optindex] + 1
                    }
                    })
                   
                    if (opt.length == optindex + 1) {
                      this.labelArray.push(oneopt.title);
                      new Chart(document.getElementById("question"+index), {
                      type: "bar",
                      data: {
                          labels: this.labelArray,
                          datasets: [
                            {
                              label: "",
                              backgroundColor: [
                                "#3e95cd",
                                "#8e5ea2",
                                "#3cba9f",
                                "#e8c3b9",
                                "#c45850"
                              ],
                              data: this.selectedOptions
                            }
                          ]
                        },
                      options: {
                        scales: {
                          yAxes: [
                            {
                              ticks: {
                                min: 0,
                                max: 100,
                                callback: function(value) {
                                  return value + "%";
                                }
                              },
                              scaleLabel: {
                                display: true,
                                labelString: "Percentage"
                              }
                            }
                          ]
                        }
                      }
                    });
         } else {
                      this.labelArray.push(oneopt.title);
                    }
                  }
                  this.counterA++;
                });
              });
            });
          }, 1000);
        this.questionsArray = response.data.questions;
        }
      })
    },
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    printReport: function() {
      window.print();
    }
  }
};
</script>
<style scoped>
.myNavbar {
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1), 0 5px 5px rgba(0, 0, 0, 0.1) !important;
}
.container-bdr {
  border-top: 1px solid #ebe9e9;
  border-right: 1px solid #ebe9e9;
}
.col-bdr-bottom {
  border-bottom: 0.5px solid #ebe9e9;
  border-left: 0.5px solid #ebe9e9;
}
.nav-route-link {
  background: none !important;
  border-right: 0px !important;
}
.chart-container {
  position: relative;
  margin: auto;
  height: 340px;
  width: 340px;
}
.chart-container-sm {
  position: relative;
  margin: auto;
  height: 250px;
  width: 250px;
}
@media print {
  .print-btn {
    display: none;
  }
  .col-bdr-bottom {
    border-bottom: none !important;
    border-left: none !important;
  }
  .container-bdr {
    border-top: none !important;
    border-right: none !important;
  }
}
</style>
<style>
.vs-navbar--header {
  height: 60px;
  padding: 20px;
}
.vs-con-items {
  padding: 20px;
}
@media screen and (max-width: 800px) {
  .vs-con-items.activeMenuResponsive {
    background-color: #46637a !important;
  }
}
</style>